import React, { useEffect } from 'react';
import '../styles/index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import TotalCount from './total-unit-count';
import TotalBookedUnitCount from './total-booked-count';

function DataTable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='datatable h-100 border rounded'>
      <table className='table mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 1 ? 'text-start bg-table-head' : 'text-center bg-table-head'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index} className='border-top'>
                      <td className='align-middle text-center'>{index + 1}</td>
                      <td
                        className="align-middle cursor-pointer text-primary"
                        onClick={() => navigate('details', { state: { items: tb_items } })}
                      >
                        {tb_items.name}
                      </td>
                      <td className="align-middle text-center">{tb_items.locality}</td>
                      <td className="align-middle text-center">{tb_items.city}</td>
                      <td className="align-middle text-center">{tb_items.state}</td>
                      <td className="align-middle text-center">
                        <TotalCount propID={tb_items.id} />
                      </td>
                      <td className="align-middle text-center">
                        <TotalBookedUnitCount propID={tb_items.id} />
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default DataTable;
